import * as _ from 'lodash';

import * as types from './types';
import { DCImportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  MatchTypeEnum,
  DefaultConfigOptionEnum,
} from '../../helpers/Constants';

const INITIAL_STATE = {
  fileConfig: {
    [Fields.Delimiter]: ',',
    [Fields.MatchOn]: MatchTypeEnum.StudentNumber,
    [Fields.UseCaseTypeMapping]: false,
    [Fields.DefaultCaseType]: undefined,
    [Fields.ImportType]: undefined,
    [Fields.ContainsHeaderInformation]: false,
    [Fields.UseAddressInFile]: false,
    [Fields.CreateFamilies]: true,
    [Fields.HeaderMapping]: [],
    [Fields.IgnoreStateNumberLeadingZeros]: false,
  },
  selectedConfigId: DefaultConfigOptionEnum.Blank,
  selectedConfigName: '',
  fetching: false,
  fetchError: null,
  fileData: [],
  fileName: '',
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.DCIMPORT_FILECONFIG_SAVE_FILE:
      return {
        ...state,
        fileData: payload.file.data.Data,
        fileName: payload.name,
      };
    case types.DC_IMPORT_SAVE_FILE_CONFIG:
      return { ...state, fileConfig: payload };
    case types.DC_IMPORT_SAVE_SELECTED_CONFIG_ID:
      return { ...state, selectedConfigId: payload };
    case types.DC_IMPORT_SAVE_CONFIG_NAME:
      return { ...state, selectedConfigName: payload };
    case types.DC_IMPORT_SAVE_SELECTED_CONFIG:
      return {
        ...state,
        fileConfig: payload.data
          ? payload.data
          : _.cloneDeep(INITIAL_STATE.fileConfig),
        selectedConfigId: payload.id,
        selectedConfigName: payload.name,
        fileData: [],
        fileName: '',
      };
    case types.DC_IMPORT_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.DC_IMPORT_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/common/reducer.js